'use client';
import { useState, useEffect } from 'react';
export function useTraceStats() {
    const [stats, setStats] = useState({
        activeRequests: 0,
        avgLatency: 0,
        cacheHits: 0,
        cacheMisses: 0,
    });
    const [recentRequests, setRecentRequests] = useState([]);
    useEffect(() => {
        let _requestCount = 0;
        let totalDuration = 0;
        let _sampleCount = 0;
        // Monitor network requests using PerformanceObserver
        const observer = new PerformanceObserver(list => {
            for (const entry of list.getEntries()) {
                if (entry.entryType === 'resource' || entry.entryType === 'navigation') {
                    _requestCount++;
                    totalDuration += entry.duration;
                    _sampleCount++;
                }
            }
        });
        // Observe resource timing
        try {
            observer.observe({ entryTypes: ['resource', 'navigation'] });
        }
        catch {
            // Fallback if observer not supported
            console.warn('[DevTools] PerformanceObserver not supported');
        }
        // Update stats periodically
        const updateStats = () => {
            // Get recent entries from the last 5 seconds
            if (typeof performance !== 'undefined') {
                const now = performance.now();
                const entries = performance.getEntriesByType('resource');
                // Filter to only fetch/XHR requests (actual API calls)
                const apiRequests = entries.filter(e => {
                    const isRecent = now - e.startTime < 5000;
                    const isFetchOrXHR = e.initiatorType === 'fetch' || e.initiatorType === 'xmlhttprequest';
                    return isRecent && isFetchOrXHR;
                });
                // Map to request info
                const requestList = apiRequests.slice(-10).map(e => ({
                    url: new URL(e.name).pathname,
                    duration: Math.round(e.duration),
                    timestamp: Date.now() - (now - e.startTime),
                    type: e.initiatorType,
                }));
                setRecentRequests(requestList);
                setStats({
                    activeRequests: apiRequests.length,
                    avgLatency: apiRequests.length > 0
                        ? Math.round(apiRequests.reduce((sum, e) => sum + e.duration, 0) / apiRequests.length)
                        : 0,
                    cacheHits: 0,
                    cacheMisses: 0,
                });
            }
        };
        updateStats();
        const interval = setInterval(updateStats, 1000);
        return () => {
            observer.disconnect();
            clearInterval(interval);
        };
    }, []);
    return { ...stats, recentRequests };
}
